<script>
    export let size = 28;
    export let click;
    export let expandedMap;
    export let mobileOnly = true;

    import { fly } from 'svelte/transition';
    import Icon360 from './Icon360.svelte'
    import IconMap from './IconMap.svelte'

</script>

<style>
  .tour-button {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 15px;
    width: 75%;
    z-index: 900;
    margin: auto;
    text-align: center;
    color: #fff;
    font-size: 1.5em;
    border-radius: 5px;
    padding: 0.5em 0.75em;
    background-color: #001021;

    display: flex;
    justify-content: center;
    align-items: center;
    
  }

  .map-button {
    position: fixed;
    left: 12px;
    bottom: 6px;
    z-index: 900;
    padding: 6px;
    text-align: center;
    color: #fff;
  }

  label {
    font-family: 'Raleway';
  }

  .map-button label {
    display: block;
    font-size: 8px;
  }

  .map-button img {
    display: block;
    margin: auto;
  }

  .tour-button img {
    margin-right: 0.25em;
  }

  .tour-button label {
    margin-right: 0.25em;
  }

  .mobile-only {
    display: none;
  }

  @media only screen and (max-width: 600px) {
    .mobile-only.map-button{
      display: block;
    }

    .mobile-only.tour-button{
      display: flex;
    }
  }

</style>
{#if !expandedMap}
<div class="map-button" class:mobile-only={mobileOnly} on:click={click} transition:fly={{y: 300, duration: 500 }}>
  <IconMap size={size}/>
  <label>Show Map</label>
</div>
{:else}
<div class="tour-button" class:mobile-only={mobileOnly} on:click={click} transition:fly={{y: 300, duration: 500 }}>
  <img src="./images/direction.png" width={size} height={size} alt="Back"/>
  <label>Back to 360 &#xb0; Tour</label>
  <Icon360 size={size}/>
</div>
{/if}

